import { PropsWithChildren, ReactElement } from "react";
import styles from "./ActivityLayout.module.less";

export const ActivityLayout = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;
	return <div className={styles.root}>{children}</div>;
};

ActivityLayout.displayName = "ActivityLayout";

const Title = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return <span className={styles.title}>{children}</span>;
};

Title.displayName = "ActivityLayout.Title";

ActivityLayout.Title = Title;

const SubText = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;
	return <span className={styles.subText}>{children}</span>;
};

SubText.displayName = "ActivityLayout.SubText";

ActivityLayout.SubText = SubText;